import {useTranslation} from 'react-i18next'
import {configLetterModuleOptions} from '../constants/configLetterModulOptions'

export const useConfigLetterModule = () => {
  const {t} = useTranslation()

  return {
    options: configLetterModuleOptions.map((item) => ({
      ...item,
      label: t(`useConfigLetterModule.${item.value}`),
    })),
  }
}
